module.exports = __webpack_public_path__ + "img/position.5e393ca4.png";